import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15c8f54c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid mt--6" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Management")
    ])
  ])
], -1))
const _hoisted_4 = {
  role: "tablist",
  class: "nav nav-pills nav-fill px-4 mt-2"
}
const _hoisted_5 = ["id", "href", "aria-controls", "aria-selected", "onClick"]
const _hoisted_6 = { class: "d-sm-block pl-2 text-uppercase" }
const _hoisted_7 = {
  key: 0,
  class: "tab-pane active px-4",
  role: "tabpanel"
}
const _hoisted_8 = { class: "text-right my-4" }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_Transition, {
        name: "custom-classes-transition",
        "enter-active-class": "animate__animated animate__fadeIn animate__faster",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs.list, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "nav-item mb-sm-3"
                }, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link d-flex justify-content-center align-items-center shadow-none", { active: item.active }]),
                    id: item.id + '-tab',
                    "data-toggle": "tab",
                    href: '#' + item.id,
                    "aria-controls": item.id,
                    role: "tab",
                    "aria-selected": item.active,
                    onClick: ($event: any) => (_ctx.onTabChanged(index))
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)
                  ], 10, _hoisted_5)
                ]))
              }), 128))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs.list, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "tab-content"
              }, [
                _createVNode(_Transition, {
                  name: "fade",
                  mode: "out-in"
                }, {
                  default: _withCtx(() => [
                    (index === _ctx.activeTabIndex)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), {
                            modelValue: _ctx.management,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.management) = $event)),
                            "view-only": ""
                          }, null, 8, ["modelValue"])),
                          _createElementVNode("div", _hoisted_8, [
                            (index == 0)
                              ? (_openBlock(), _createBlock(_component_n_button, {
                                  key: 0,
                                  class: "mr-3",
                                  type: "primary",
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/management/${_ctx.management.id}/edit`)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" UPDATE ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (index == 1)
                              ? (_openBlock(), _createBlock(_component_n_button, {
                                  key: 1,
                                  class: "mr-3",
                                  type: "primary",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(`/management/${_ctx.management.id}/document`)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" ADD DOCUMENT ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_9))
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}